const heroMenu = $('.c-hero-menu');

// Only continue if we have our hero menu element
if (heroMenu.length) {
    const currentPageId = get_current_page_id();
    const depth = get_current_depth();
    const iconMarkup = $('.js-hero-menu-back-icon-wrap').html();
    
    // Hide all the links
    heroMenu.find('[data-page-id]').hide();

    // Loop through all the links and show the appropriate ones
    heroMenu.find('[data-page-id]').each(function() {
        var element = $(this);

        // If link destination id matches current page id
        if (element.attr('data-page-id') == currentPageId) {
            switch (depth) {
                case '1':
                    element
                        .siblings('.c-sub-menu')
                        .children('.c-site-nav__item')
                        .children('[data-page-id]')
                        .css('display', '');
                break;

                case '2':
                    element
                        .closest('.c-sub-menu')
                        .siblings('[data-page-id]')
                        .css('display', '')
                        .addClass('is-parent-link')
                        .html(iconMarkup);

                    element
                        .siblings('.c-sub-menu')
                        .find('[data-page-id]')
                        .css('display', '');
                break;

                case '3':
                    element
                        .closest('.c-sub-menu')
                        .siblings('[data-page-id]')
                        .css('display', '')
                        .addClass('is-parent-link')
                        .html(iconMarkup);

                    element
                        .closest('.c-sub-menu')
                        .find('[data-page-id]')
                        .css('display', '');
                break;
            }
        }
    });

    // Set the height of the hero menu based on the height of the child element
    const heroList = heroMenu.find("ul");

    if (heroList.length) {
        setTimeout(function () {
            const childHeight = heroList.height();
            if (childHeight > 75) {
                heroMenu.height(childHeight / 2);
            }
        }, 500);
    }
}

function get_current_page_id() {
    var page_body = $('body.page');

    var id = 0;

    if(page_body) {
        var classList = page_body.attr('class').split(/\s+/);

        $.each(classList, function(index, item) {
            if (item.indexOf('page-id') >= 0) {
                var item_arr = item.split('-');
                id =  item_arr[item_arr.length -1];
                return false;
            }
        });
    }
    return id;
}

function get_current_depth() {
    var page_body = $('body.page');

    var id = 0;

    if(page_body) {
        var classList = page_body.attr('class').split(/\s+/);

        $.each(classList, function(index, item) {
            if (item.indexOf('depth') >= 0) {
                var item_arr = item.split('-');
                id =  item_arr[item_arr.length -1];
                return false;
            }
        });
    }
    return id;
}



// WEBPACK FOOTER //
// ./scripts/hero-menu.js